module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-expression-sleep-smile-svgrepo-com.68023655.svg";